module.exports = __webpack_public_path__ + "static/media/reviews-image.7b52d546.jpg";